import { Grid } from '@mui/material'
import { useContext } from 'react'
import type { SignageIf } from '../interfaces/SignageIf'
import { LanguageContext } from '../util/LanguageContext'
import { CustomCard } from './CustomCard'

type SignageListProps = {
  items: SignageIf[]
  onEditSignage: (oldText: string, newText: string, file?: File) => void
  onDeleteSignage: (id: string) => void
}
export const SignageList: React.FC<SignageListProps> = props => {
  // 文字列変換用
  const translation = useContext(LanguageContext)

  return (
    <>
      {props.items.map(signage => (
        <Grid item lg={6} xl={4}>
          <CustomCard
            title={translation['label_signage']}
            id={signage.signage_id}
            text={signage.text}
            file={signage.storage_path}
            onEdit={(oldText, newText, file) => props.onEditSignage(oldText, newText, file)}
            onDel={props.onDeleteSignage.bind(null, signage.signage_id)}
          />
        </Grid>
      ))}
    </>
  )
}
